import axiosClient from "./axiosClient";

const serviceUrl = "/api/contract-service/auth";

const ssoApiService = {
  login: async (params) => {
    const url = serviceUrl + `/signin_admin`;
    const response = await axiosClient.post(url, params);
    return response;
  },
  refreshToken: async (params) => {
    const url = `auth/refreshtoken`;
    const response = await axiosClient.post(url, params);
    return response;
  },
  logOut: async () => {
    const url = serviceUrl + `/signout`;
    const refresh_token = localStorage.getItem("refreshToken");
    const params = { refresh_token: refresh_token };
    const response = await axiosClient.post(url, {}, { params: params });
    return response;
  },
};

export default ssoApiService;
